<app-marine-insurance-card cardTitle="MARINE_INSURANCE_BY_ANOVA">
  <ng-container header-actions-button>
    <div class="marine-insurance-quote-management-header-link" (click)="uploadCertificate.emit()">
      <img src="/assets/icons/icon_paperclip_gray_sm.svg" />
      {{ "UPLOAD_REVISED_CERTIFICATE" | translate }}
    </div>

    <div class="marine-insurance-quote-management-header-link ml-3" (click)="toggleHistory()">
      <img src="/assets/icons/icon_eye_gray_sm.svg" />
      {{ "INSURANCE_POLICY_CERTIFICATE_HISTORY" | translate }}
    </div>
  </ng-container>

  <ng-container body>
    <div class="marine-insurance-quote-management">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="marine-insurance-quote-management-view-data">
            <div class="row mb-1">
              <div class="col-5 col-md-6 marine-insurance-quote-management-view-data-label">
                {{ "PROVIDER" | translate }}
              </div>
              <div class="col-7 col-md-6 marine-insurance-quote-management-view-data-value">Anova</div>
            </div>

            <div class="row mb-1">
              <div class="col-5 col-md-6 marine-insurance-quote-management-view-data-label">
                {{ "CERTIFICATE_NUMBER" | translate }}
              </div>
              <div class="col-7 col-md-6 marine-insurance-quote-management-view-data-value">{{ marineInsurance?.certificate?.number }}</div>
            </div>

            <div class="row mb-1">
              <div class="col-5 col-md-6 marine-insurance-quote-management-view-data-label">
                {{ "DATE_ISSUED" | translate }}
              </div>
              <div class="col-7 col-md-6 marine-insurance-quote-management-view-data-value">
                {{ marineInsurance?.certificate?.issueDate | customDateByUtc }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 d-md-flex flex-column align-items-md-end pt-3 pt-md-0">
          <div class="mt-1 mb-1" *ngFor="let document of documentsList">
            <document-upload-desktop
              [attachmentName]="'DOWNLOAD_POLICY_CERTIFICATE'"
              [isShowOptionalTag]="false"
              [isStripeLayout]="true"
              [isStretched]="true"
              [uploadedDocument]="document"
              (stateUpdate)="onDocumentStateUpdate(document.id, $event)"
            ></document-upload-desktop>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</app-marine-insurance-card>
